<div class="container">
  <div class="page-container">
    <router-outlet></router-outlet>
  </div>
</div>
